// Define the public path
if ((window as any).PublicPath != null)
    __webpack_public_path__ = (window as any).PublicPath;

// Import polyfill
import 'ts-polyfill/lib/es2016-array-include';
import 'ts-polyfill/lib/es2017-object';
import 'ts-polyfill/lib/es2017-string';
import 'ts-polyfill/lib/es2018-async-iterable'; // for-await-of
import 'ts-polyfill/lib/es2018-promise';
import 'ts-polyfill/lib/es2019-array';
import 'ts-polyfill/lib/es2019-object';
import 'ts-polyfill/lib/es2019-string';
import 'ts-polyfill/lib/es2019-symbol';
import 'ts-polyfill/lib/es2020-promise';
import 'ts-polyfill/lib/es2020-string';
import 'ts-polyfill/lib/es2020-symbol-wellknown';
import 'ts-polyfill/lib/es2020-global-this'; // globalThis (no tsconfig.json lib)

import { createRoot } from 'react-dom/client';
import { DebugEx } from '@Utils/DebugEx';
import { screenWidth, screenHeight } from '@Utils/Utils';
import MainAppLayout from "./Main";
import { PWAInit, PWAUnInit } from './PWA';
import { UserManager } from '@Utils/UserManager';
import { ErrorCatch } from '@Primitive/ErrorCatch';

// ================================================================================================
// Init phase
// ================================================================================================

DebugEx.LogAppInfo("Dashboard v0.2.10");

if (process.env.NODE_ENV !== 'production' &&
    process.env.USE_WHY_DID_YOU_RENDER) {
    /*const whyDidYouRender = require('@welldone-software/why-did-you-render');
    whyDidYouRender(React, {
        trackAllPureComponents: true,
    });*/
}
// ------------------------------------------------------------------------------------------------------
// Init PWA
if (process.env.GLOW_BUILD) {
    PWAUnInit();
} else {
    PWAInit();
}
// Run the react recreation
const container = document.getElementById('app-mount-point');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
// ------------------------------------------------------------------------------------------------------
function appRender() {
    root.render(<ErrorCatch>
        <MainAppLayout
            width={screenWidth()}
            height={screenHeight()} />
    </ErrorCatch>);
}
function appRenderDelay() {
    setTimeout(appRender, 1);
}
// ------------------------------------------------------------------------------------------------------
// Login phase
if (process.env.GLOW_BUILD) {
    UserManager.GetInstance()
        .init()
        .then(user => {
            DebugEx.TraceLog("App loaded");

            appRender();

            // If the browser resized redraw everything
            window.addEventListener('resize', appRenderDelay);
            window.addEventListener('orientationchange', appRenderDelay);

        });
} else {
    // If the browser resized redraw everything
    window.addEventListener('resize', appRenderDelay);
    window.addEventListener('orientationchange', appRenderDelay);

    appRender();
}
// ------------------------------------------------------------------------------------------------------